module.exports = __webpack_public_path__ + "img/OLOV_citat.f5bd5e66.png";